import { useAuthenticationRequirementsRouting } from './useAuthenticationRequirementsRouting';
import { usePasswordLogin } from './usePasswordLogin';

const useForeFlightAuthentication = () => {
    const {
        onAuthenticationRequirementsCheck,
        resendContactCodeEmail,
        isPasswordLoginAllowed,
        hasFetchedRequirements,
        isLoading: isRequirementsLoading,
        alerts: requirementsAlerts,
        resetAlerts: resetRequirementsAlerts,
        reset: requirementsReset,
    } = useAuthenticationRequirementsRouting();

    const {
        onPasswordLogin,
        isMfaRequired,
        isLoading: isPasswordLoginLoading,
        alerts: passwordLoginAlerts,
        resetAlerts: resetPasswordAlerts,
        reset: passwordLoginReset,
    } = usePasswordLogin();

    const onReset = () => {
        passwordLoginReset();
        requirementsReset();
    };

    const resetAlerts = () => {
        resetRequirementsAlerts();
        resetPasswordAlerts();
    };

    return {
        onAuthenticationRequirementsCheck,
        resendContactCodeEmail,
        isPasswordLoginAllowed,
        hasFetchedRequirements,
        onPasswordLogin,
        showVerifyCodeInput: isMfaRequired,
        isLoading: isRequirementsLoading || isPasswordLoginLoading,
        alerts: [...requirementsAlerts, ...passwordLoginAlerts],
        resetAlerts,
        reset: onReset,
    };
};
export default useForeFlightAuthentication;
